<template>
    <div>
        <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />

        <div>
            <div class="row">
                <div class="col-lg-4 d-flex">
                    <card class="card-eprf">
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                            JOB INFORMATION
                        </p>
                        <div style="height: 520px; overflow: auto; overflow-x: hidden">
                            <p class="new-title">Job Reference No.</p>
                            <p class="subtitle">{{ refno }}</p>

                            <p class="new-title">Service Location</p>
                            <p class="subtitle">
                                {{ servicelocation }}
                            </p>

                            <p class="new-title">PIC Full Name</p>
                            <p class="subtitle">
                                {{ picfullname }}
                            </p>

                            <p class="new-title">PIC Phone No.</p>
                            <p class="subtitle">
                                {{ picphoneno }}
                            </p>

                            <p class="new-title">PIC Fax No.</p>
                            <p class="subtitle">
                                {{ picfaxno }}
                            </p>

                            <p class="new-title">PIC Email</p>
                            <p class="subtitle">
                                {{ picemail }}
                            </p>
                        </div>
                    </card>
                </div>
                <div class="col-lg-4 d-flex">
                    <card style="
                box-shadow: none;
                color: #A5A5A5;
                padding: 0px 0px 30px 30px;
  
                background-color: white;
              ">
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                            TRANSPORTER DETAILS
                        </p>
                        <div style="height: 490px; overflow: auto; overflow-x: hidden">
                            <p class="new-title">
                                Transporter Name <span v-if="displayflag" style="color: #EC1B23">*</span>
                            </p>
                            <p v-if="!displayflag" class="subtitle">
                                {{ transportername }}
                            </p>

                            <el-select v-if="displayflag" class="select-info tab select-width"
                                popper-class="custom-dropdown" placeholder="Select" v-model="selects.transporter"
                                style="width: 90%; border-bottom: 1px solid lightgray">
                                <el-option v-for="option in selects.transporters" class="select-info custom-option"
                                    :value="option.value" :label="option.label" :key="option.value"></el-option>
                            </el-select>

                            <p class="new-title">DOE No.</p>
                            <p class="subtitle">
                                {{ doeno }}
                            </p>

                            <p class="new-title">Company Address</p>
                            <p class="subtitle">
                                {{ companyaddress }}
                            </p>

                            <p class="new-title">Phone No. / Fax No.</p>
                            <p class="subtitle">
                                {{ phoneno }} / {{ faxno }}
                            </p>
                        </div>
                    </card>
                </div>
                <div class="col-lg-4 d-flex">
                    <card style="
                box-shadow: none;
                color: #A5A5A5;
                padding: 0px 0px 30px 30px;
  
                background-color: white;
              ">
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                            VEHICLE DETAILS
                        </p>
                        <p class="new-title">
                            Vehicle Registration No. <span v-if="displayflag" style="color: #EC1B23">*</span>
                        </p>
                        <p v-if="!displayflag" class="subtitle">
                            {{ vehicleregno }}
                        </p>

                        <el-select v-if="displayflag" class="select-info tab select-width"
                            popper-class="custom-dropdown" placeholder="Select" v-model="selects.vehicle"
                            style="width: 90%; border-bottom: 1px solid lightgray">
                            <el-option v-for="option in selects.vehicles" class="select-info custom-option"
                                :value="option.value" :label="option.label" :key="option.value"></el-option>
                        </el-select>

                        <br /><br /><br />
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                            DRIVER DETAILS
                        </p>
                        <p class="new-title">
                            Driver Name <span v-if="displayflag" style="color: #EC1B23">*</span>
                        </p>
                        <p v-if="!displayflag" class="subtitle">
                            {{ drivername }}
                        </p>

                        <p class="new-title">
                            Driver NRIC <span v-if="displayflag" style="color: #EC1B23">*</span>
                        </p>
                        <p v-if="!displayflag" class="subtitle">
                            {{ driveric }}
                        </p>

                        <el-select v-if="displayflag" class="select-info tab select-width"
                            popper-class="custom-dropdown" placeholder="Select" v-model="selects.driver"
                            style="width: 90%; border-bottom: 1px solid lightgray">
                            <el-option v-for="option in selects.drivers" class="select-info custom-option"
                                :value="option.value" :label="option.label" :key="option.value"></el-option>
                        </el-select>
                        <br />
                    </card>
                </div>
            </div>

            <div class="row">
                <div class="col-lg"></div>
                <div class="col-lg-3 text-right">
                    <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp;
                    <!-- <base-button v-if="status < 3" type="primary" v-on:click="redirect()">Exit</base-button> -->
                    <base-button v-if="displayflag" type="primary" v-on:click="setTransporter()">Submit</base-button>
                    <base-button v-if="!displayflag" type="primary" v-on:click="nextTab()">Next</base-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
    components: {
        StatusModal,
        ImageUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Circle8,
        Modal,
        BCard,
    },

    data() {
        return {
            modal: modal,
            refno: '',
            servicelocation: '',
            picfullname: '',
            picphoneno: '',
            picfaxno: '',
            picemail: '',
            status: 0,
            displayflag: false,

            transportername: '',
            doeno: '',
            companyaddress: '',
            phoneno: '',
            faxno: '',

            vehicleregno: '',
            drivername: '',
            driveric: "",
            selects: {
                transporter: "",
                transporters: [
                ],

                vehicle: "",
                vehicles: [
                ],

                driver: "",
                drivers: [
                ],
            },

            modals: {
                submit: false,
                warningsubmit: false,
                supportdoc: false,
                successModal: false,
            },
        };
    },
    created() {
        this.getTransporter();
        this.getData();

        console.log(this.status);


    },
    mounted() {
    },
    computed: {
    },
    watch: {
        "selects.transporter"() {
            this.getVehicle();
            this.getDriver();

            for (var i = 0; i < this.selects.transporters.length; i++) {
                if (this.selects.transporter == this.selects.transporters[i].value) {
                    this.doeno =
                        this.selects.transporters[i].doeno == "" ||
                            this.selects.transporters[i].doeno == null
                            ? "N/A"
                            : this.selects.transporters[i].doeno;
                    this.phoneno =
                        this.selects.transporters[i].phoneno == "" ||
                            this.selects.transporters[i].phoneno == null
                            ? "N/A"
                            : this.selects.transporters[i].phoneno;
                    this.companyaddress =
                        this.selects.transporters[i].address == "" ||
                            this.selects.transporters[i].address == null
                            ? "N/A"
                            : this.selects.transporters[i].address;
                    this.faxno =
                        this.selects.transporters[i].faxno == "" ||
                            this.selects.transporters[i].faxno == null
                            ? "N/A"
                            : this.selects.transporters[i].faxno;
                }
            }
        }
    },
    methods: {
        validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        // this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
        redirect() {
            this.$router.push("/Vendor/Job");
        },
        setTransporter() {
            let obj = {
                transporter_id: this.selects.transporter,
                driver_id: this.selects.driver,
                vehicle_id: this.selects.vehicle
            };
            console.log(obj);
            this.$http
                .post(
                    ":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid + "/vendor/transporter", obj
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Set transporter success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.redirect();
                            }
                        });
                    } else {
                        console.log("quote not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Set transporter failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },
        getData() {
            this.$http.get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid).then((res) => {
                if (!res.error) {
                    let response = res.message;
                    console.log(response)

                    this.refno = response.reference_number;
                    this.servicelocation = response.service_location.location;
                    this.picfullname = response.assign_to_afes.user_name;
                    this.picphoneno = response.assign_to_afes.phone_number == null || response.assign_to_afes.phone_number == '' ? 'N/A' : response.assign_to_afes.phone_number;
                    this.picfaxno = response.assign_to_afes.fax_number == null || response.assign_to_afes.fax_number == '' ? 'N/A' : response.assign_to_afes.fax_number;
                    this.picemail = response.assign_to_afes.email == null || response.assign_to_afes.email == '' ? 'N/A' : response.assign_to_afes.email;
                    this.status = response.status.status;

                    console.log('status is here', this.status);

                    if (this.$route.params.action == "edit" && this.status == 2) {
                        this.displayflag = true;
                    }

                    // if (this.$route.params.action == "edit" && this.status == 3) {
                    //     this.nextTab();
                    // }

                    if (response.transporter != null) {
                        this.transportername = response.transporter.transporter_name;
                        this.doeno = response.transporter.doe_no == null || response.transporter.doe_no == '' ? 'N/A' : response.transporter.doe_no;
                        this.companyaddress = response.transporter.transporter_address;
                        this.phoneno = response.transporter.transporter_phone == null || response.transporter.transporter_phone == '' ? 'N/A' : response.transporter.transporter_phone;
                        this.faxno = response.transporter.doe_no == null || response.transporter.transporter_fax == '' ? 'N/A' : response.transporter.transporter_fax;
                    }
                    if (response.transporter == null) {
                        this.transportername = 'N/A';
                        this.doeno = 'N/A';
                        this.companyaddress = 'N/A';
                        this.phoneno = 'N/A';
                        this.faxno = 'N/A';
                    }

                    if (response.vehicle != null) {
                        this.vehicleregno = response.vehicle.vehicle_reg_num == null || response.vehicle.vehicle_reg_num == '' ? 'N/A' : response.vehicle.vehicle_reg_num;
                    }

                    if (response.vehicle == null) {
                        this.vehicleregno = 'N/A';
                    }

                    if (response.driver != null) {
                        this.drivername = response.driver.driver_name == null || response.driver.driver_name == '' ? 'N/A' : response.driver.driver_name;
                        this.driveric = response.driver.driver_nric == "" ? "N/A" : response.driver.driver_nric
                    }

                    if (response.driver == null) {
                        this.drivername = 'N/A';
                    }

                }
            });
        },
        prevTab() {
            let parameter = {
                step: "2",
                direction: "blkg",
                data: [],
            };
            this.$emit("my-event", parameter);
        },
        nextTab() {
            let parameter = {
                step: "2",
                direction: "depan",
                data: [],
            };
            this.$emit("my-event", parameter);
        },
        getTransporter() {
            this.selects.transporters = [];
            this.$http.get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid + "/vendor/transporter").then((res) => {
                if (!res.error) {
                    let response = res.message;
                    console.log(response);

                    for (var i = 0; i < response.length; i++) {
                        let obj = {
                            label: response[i].transporter_name,
                            value: response[i].transporter_id,
                            doeno: response[i].doe_no,
                            address: response[i].transporter_address,
                            phoneno: response[i].transporter_phone,
                        };

                        this.selects.transporters.push(obj);
                    }

                    // this.selects.transporter = this.selects.transporters[0].value;
                }
            });
        },
        getVehicle() {
            this.selects.vehicles = [];
            this.$http.get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid + "/vendor/transporter").then((res) => {
                if (!res.error) {
                    let response = res.message;
                    const index = response.findIndex(transporter => transporter.transporter_id === this.selects.transporter);

                    console.log(index)

                    for (var i = 0; i < response[index].vehicle.length; i++) {
                        let obj = {
                            label: response[index].vehicle[i].vehicle_reg_num,
                            value: response[index].vehicle[i].vehicle_id,
                        };

                        this.selects.vehicles.push(obj);
                    }

                    this.selects.vehicle = this.selects.vehicles[0].value;
                }
            });
        },
        getDriver() {
            this.selects.drivers = [];
            this.$http.get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid + "/vendor/transporter").then((res) => {
                if (!res.error) {
                    let response = res.message;
                    const index = response.findIndex(transporter => transporter.transporter_id === this.selects.transporter);

                    console.log(index)

                    for (var i = 0; i < response[index].driver.length; i++) {
                        let obj = {
                            label: response[index].driver[i].driver_name,
                            value: response[index].driver[i].driver_id,
                        };

                        this.selects.drivers.push(obj);
                    }

                    this.selects.driver = this.selects.drivers[0].value;
                }
            });
        },
    },
};
</script>
<style scoped>
.swcode-text {
    color: #707070;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.new-title {
    margin-top: 20px;
    color: #A5A5A5;
}

.subtitle {
    color: #A5A5A5;
    text-align: left;
    font-weight: 600;
    font-size: 18px;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
    color: #A5A5A5 !important;
}

.custom-dropdown-2 {
    width: 300px;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.overlay-content {
    background: transparent;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    z-index: 9999;
}

.link {
    cursor: pointer;
}

.link:hover {
    text-decoration: underline;
    cursor: pointer;
}

::-webkit-scrollbar {
    width: 10px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: #dce9ff;
    border-radius: 15px;
}

::-webkit-scrollbar-thumb {
    background: #5e99ff;
    border-radius: 15px;
}

::-webkit-scrollbar-thumb:hover {
    background: #176bfd;
}

.custom-table .el-table__body-wrapper {
    overflow-y: scroll;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar {
    width: 12px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #358dcc;
    border-radius: 6px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

.custom-input {
    padding: 5px 5px 5px 5px;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid lightgray;
    outline: none;
    font-size: 16px;
    width: 100%;
}
</style>